/* eslint-disable  react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Circle = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border-radius: var(--cc_size_border_radius_m);
  cursor: pointer;
  background-color: ${(props) => (props.selected ? props.color : 'transparent')};
  border: 2px solid;
  border-color: ${(props) => (props.isDatePicker ? 'var(--cc_color_border_input_inactive)' : 'white')};
  color: white;

  i {
    opacity: ${(props) => (props.selected ? 1 : 0)};
    margin: 0;
  }

  &:hover {
    transition-delay: 0ms;
    background-color: ${(props) => props.color};

    i {
      opacity: 1;
    }
  }

  &:active {
    transform: scale(0.9);

    &&::before,
    &&::after {
      display: none;
    }
  }

  &:focus {
    outline: none;
  }
`;

const SelectCircle = ({ visible, color, selected, type, ...props }) =>
  !visible ? null : (
    <Circle color={color} type={type} selected={selected} {...props}>
      <i className="mdi mdi-check" />
    </Circle>
  );

SelectCircle.propTypes = {
  visible: PropTypes.bool,
  color: PropTypes.string,
  type: PropTypes.string,
  selected: PropTypes.bool,
};

SelectCircle.defaultProps = {
  visible: true,
  color: "var(--cc_color_brand_primary)",
  selected: false,
};

export default SelectCircle;
